import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { AppKey } from '../app';
import { YelpZapierSetupService } from './yelp-zapier-setup.service';

@Component({
  selector: 'rosie-yelp-zapier-callback',
  template: `
    <div class="d-flex flex-column align-items-center justify-content-center gap-3 py-5">
      <rosie-loader></rosie-loader>
      <span>{{ 'APP.YELP.SETUP.CONNECTING_ZAPIER' | translate }}</span>
    </div>
  `,
  standalone: false,
})
export class YelpZapierCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private yelpZapierSetupService: YelpZapierSetupService,
    private messageService: MessageService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.pipe(take(1)).subscribe((params) => {
      const code = params.get('code');
      const state = params.get('state');

      if (params.get('error') || !code || !state) {
        this.finish(this.translate.instant('APP.YELP.SETUP.ZAPIER_NOT_CONNECTED'));
        return;
      }

      this.yelpZapierSetupService.connect(code, state).subscribe({
        next: () => this.finish(),
        error: (error) => this.finish((typeof error === 'string' && error) || this.translate.instant('APP.YELP.SETUP.ZAPIER_NOT_CONNECTED')),
      });
    });
  }

  private finish(errorMessage?: string): void {
    if (errorMessage) {
      this.messageService.add({ severity: 'error', detail: errorMessage, life: 8000 });
    }

    this.router.navigate(['/integrations', { id: AppKey.Yelp }], { replaceUrl: true });
  }
}
